module.exports = __webpack_public_path__ + "static/media/logo_draft.8a03bbac.png";